import { compose } from 'redux'
import { connect } from 'react-redux'
import { listar_obj,salvar_obj } from '../../../../../DinamicForms/actions';



const mapStateToProps = (state, props) => {
    const { DinamicCustomFormsReducer } = state
    const controler = DinamicCustomFormsReducer.rLista;
    let lista = controler.lista;
    let customFormInterno = null;
    lista.forEach(f => {
        if (f.uid === props.item.customFormUid) {
            customFormInterno = f;
        }
    });

    let chaveReducer = props.item.customFormUid;
    let loading = true;
    let listaItens = []

    if (customFormInterno) {
        if (customFormInterno.chaveSalvar) {
            chaveReducer = customFormInterno.chaveSalvar
        }


        if (DinamicCustomFormsReducer.rListaObj[chaveReducer]) {
            loading = DinamicCustomFormsReducer.rListaObj[chaveReducer].loading;
            listaItens = DinamicCustomFormsReducer.rListaObj[chaveReducer].lista;
        }
    }

    let listaFinal = [];
    if (listaItens) {
        let funcFiltro = props.funcFiltro;
        if (funcFiltro) {
            try {

                listaFinal = listaItens.filter(funcFiltro)
            } catch (error) {

                listaFinal = listaItens.slice()
            }
        } else {

            listaFinal = listaItens.slice()
        }
    }



    return {
        customFormInterno, lista: listaFinal, loading
    };
};

export default compose(
    connect(mapStateToProps, { listar: listar_obj,salvarItem: salvar_obj })

);


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/GantListaFiltrada/components/GantComponent/GantComponent.enhancer.js